import React from 'react';
export function ServiceHero() {
  return <section className="w-full bg-white pt-16 md:pt-20 pb-12 md:pb-14 px-4 sm:px-6 lg:px-8" data-id="element-292" data-mp="3gp0pciefw9l">
      <div className="max-w-4xl mx-auto" data-id="element-293" data-mp="s27v1e27ede4">
        <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-brand-navy mb-10 leading-tight" data-id="element-294" data-mp="napw0vjqqmvs">
          Team AI Capability Program
        </h1>
        <p className="text-xl md:text-2xl text-brand-gray leading-relaxed mb-16" data-id="element-295" data-mp="ibd96asvdft7">
          A structured, multi-week program that gets your entire team working
          with AI in a coordinated way. Not just the early adopters.
          Experienced leadership drives the process. AI accelerates what's
          possible.
        </p>

        <div className="bg-brand-light-gray p-10 rounded-lg border-l-4 border-brand-orange shadow-sm" data-id="element-296" data-mp="3vig56xf1ce8f">
          <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-297" data-mp="1ypwey443c3e4">
            Who it's for
          </h2>
          <p className="text-lg text-brand-gray leading-relaxed" data-id="element-298" data-mp="1trbgoa8eftsb">
            Leaders responsible for the effectiveness of a team. Whether that's
            a product organization, an architecture studio, or a professional
            services practice. If your team is using AI unevenly or not at all,
            and you need to get everyone on the same page before the gap gets
            wider, this is built for you.
          </p>
        </div>
      </div>
    </section>;
}